<template>
  <v-container>
    <p>This is Team Page</p>
  </v-container>
</template>

<script>
export default {};
</script>
